<template>
	<div class="payment">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('payment.edit')"
			:visible.sync="dialogPayment"
			width="850px"
			top="6vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					ref="payment"
					label-width="80px"
					:model="payment.payConfig">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item :label="$t('payment.creditCard')" prop="isCard">
								<el-select
									v-model="payment.payConfig.isCard"
									:disabled="$tools.IsGrayModule('usermahcine:gray:iscard')"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('payment.select')">
									<el-option
										v-for="item in yesNo"
										:key="item.id"
										:label="item.label"
										:value="+item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col v-if="payment.payConfig.isCard == 1" :span="12">
							<el-form-item :label="$t('payment.cardReader')" prop="cardType">
								<el-select
									v-model="payment.payConfig.cardType"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('payment.select')">
									<el-option
										v-for="item in shuaKaQi"
										:key="item.id"
										:label="item.label"
										:value="+item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')" size="small">{{
					$t("common.cancel")
				}}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('payment')"
					size="small"
					>{{ $t("common.definite") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "Payment",
	props: {
		dialogPayment: Boolean,
		payment: Object,
		yesNo: Array,
		shuaKaQi: Array,
	},
	data() {
		return {
			labelPosition: "top",
			loadingForm: false,
		};
	},
	methods: {
		closeDialog() {
			this.cancel("");
		},

		openDialog() {
		},

		cancel(state) {
			this.$emit("cancelPayment", false, state);
		},

		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					this.$api
						.request(
							this.$url.UserMachine.payment,
							this.$method.put,
							this.payment
						)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								this.cancel(this.payment.id ? "update" : "save");
							}
							this.loadingForm = false;
						})
						.catch(() => {
							this.loadingForm = false;
						});
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
	border-radius: 6px;
	font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
		"Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	.el-dialog__header {
		padding: 15px 15px 15px 20px;
		background-color: #409eff;
		border-radius: 5px 5px 0 0;
	}
	.el-dialog__headerbtn .el-dialog__close {
		color: white;
	}
	.el-dialog__title {
		color: white;
	}
	.el-dialog__body {
		padding: 20px 20px 0 20px;
	}
	.el-dialog__footer {
		padding: 20px;
	}
	.el-form--label-top .el-form-item__label {
		padding: 0;
	}
	.el-form-item {
		margin: 0;
	}
	.el-dialog__headerbtn {
		top: 20px;
		right: 15px;
	}
}
</style>
